import React, { useRef } from "react";
import Youtube from "react-youtube";

import Button from "components/ui/Button";
import { FRONT_URL } from "lib/config";
import { ArrowLeft, ArrowRight, FullscreenIcon } from "features/player/icons";

// Right panel: lesson title, the video, and a footer to move freely between
// lessons (Previous / Next) and mark this one complete or not.
// Uploaded lessons store a file name (up_<id>.mp4) instead of a YouTube id.
const isUpload = (video) => /\.(mp4|webm|mov|m4v)$/i.test(video || "");

export default function PlayerStage({ course, current, prev, next, goTo, isDone, percent, saving, setComplete }) {
  const stage = useRef(null);

  function fullscreen() {
    const el = stage.current;
    if (!el) return;
    if (document.fullscreenElement) {
      if (document.exitFullscreen) document.exitFullscreen();
    } else if (el.requestFullscreen) el.requestFullscreen();
  }

  return (
    <main className="yc-player-stage" ref={stage}>
      <div className="yc-player-stage-head">
        <h2>{current.name}</h2>
        <button type="button" className="yc-player-icon-btn" onClick={fullscreen} aria-label="Full screen">
          <FullscreenIcon />
        </button>
      </div>

      <div className="yc-player-stage-body">
        <div className="yc-player-video">
          {current.video && isUpload(current.video) && (
            <video
              key={current.video}
              className="yc-player-file"
              src={`${process.env.REACT_APP_API_HOST}/videos/${current.video}`}
              controls
              autoPlay
              playsInline
              preload="metadata"
              onEnded={() => !isDone && setComplete(current, true)}
            />
          )}
          {current.video && !isUpload(current.video) && (
            <Youtube
              key={current.video}
              videoId={current.video}
              id={current.video}
              opts={{ width: "100%", height: "100%", playerVars: { autoplay: 1, controls: 1, rel: 0, modestbranding: 1 } }}
              onEnd={() => !isDone && setComplete(current, true)}
            />
          )}
        </div>
        {percent >= 100 && (
          <div className="yc-player-done">
            <strong>Tahniah, you finished {course?.name}! 🎉</strong>
            <span>
              Every lesson is done. <a href={`${FRONT_URL}/courses`}>Find your next class →</a>
            </span>
          </div>
        )}
      </div>

      <div className="yc-player-stage-foot">
        <Button variant="secondary" size="lg" onClick={() => goTo(prev)} disabled={!prev}>
          <ArrowLeft />
          Previous
        </Button>
        <Button
          variant={isDone ? "secondary" : "primary"}
          size="lg"
          className="yc-player-complete"
          aria-pressed={isDone}
          onClick={() => setComplete(current, !isDone)}
          disabled={saving}
        >
          {isDone ? "✓ Completed" : "Mark as complete"}
        </Button>
        <Button variant="secondary" size="lg" onClick={() => goTo(next)} disabled={!next}>
          Next
          <ArrowRight />
        </Button>
      </div>
    </main>
  );
}
